query GetRecentUserTemplates($limit: Int!, $status: Int!) {
    recentUserTemplates(limit: $limit, status: $status) {
        id
        name
        createdTime
        modifiedTime
        status
        htmlUrlPath
        viewInBrowserLink
        backgroundColor
        emailTemplate {
            id
            thumbnailUrl
        }
        campaign {
            id
            type
            owner {
                id
                name
            }
        }
    }
}
